import React from "react";

export default function MembershipServiceAgreement() {
  return (
    <div className="agreement-page" style={{ padding: "20px", maxWidth: "900px", margin: "0 auto" }}>
      <h1>伴知宠会员服务协议</h1>
      <p>
        本页面为《伴知宠会员服务协议》的展示页。具体会员权益、服务内容及条款请以伴知宠官方最新公布为准。
      </p>
      <p>
        您开通或使用伴知宠会员服务时，即表示同意受该协议约束。
      </p>
    </div>
  );
}
